import { AppState } from "../../../redux-configuration/AppState";

export const deleteMunicipalityServiceLoadingSelector = (appState: AppState): boolean => appState.municipality.deleteService.loading
export const deleteMunicipalityServiceErrorSelector = (appState: AppState): string | undefined => appState.municipality.deleteService.error
